import React from 'react';
import T from "prop-types";
import { AddressRow } from '../../molecules';

export const VerticalPrintAddress = ({
    address1,
    address2,
    postalCode,
    city,
    country,
    label,
    text,
    ifText,
    ifCustomerName,
    customerName,
    titleCls,
    textCls
}) => {
    return (
        <div className='verticalDiv'>
            <AddressRow
                title={label}
                titleCls={titleCls}
                boxCls={textCls}
                textCls={'printTextCls text'}
                address1={address1}
                address2={address2}
                postalCode={postalCode}
                city={city}
                country={country}
                ifText={ifText}
                text={text}
                ifCustomerName={ifCustomerName}
                customerName={customerName}
            />
        </div>
    )
}

VerticalPrintAddress.T = {
    ifText: T.bool,
    ifCustomerName: T.bool,
};

VerticalPrintAddress.defaultProps = {
    ifText: false,
    titleCls: 'printTopTitle',
    textCls: 'printTextCls'
};
